import React, { useEffect, useState } from "react";
import {
  Box, Typography, TextField, Button, Grid,
  FormControl, RadioGroup, FormControlLabel, Radio,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";

import { fetchCustomerType, updateCustomerType } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";

export default function CustomerTypeEditPage() {
  const { businessDomainId, customerTypeId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });

  const [form, setForm] = useState({
    customerTypeId: "",
    companyId: "",
    businessDomainId: "",
    customerTypeName: "",
    personality: "",
    values: "",
  });
  const [fullData, setFullData] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const d = await fetchCustomerType(customerTypeId);
        setFullData(d);
        setForm({
          customerTypeId: d.customerTypeId || "",
          companyId: d.companyId || "",
          businessDomainId: d.businessDomainId || "",
          customerTypeName: d.customerTypeName || "",
          personality: d.personality || "",
          values: d.values || "",
        });
      } catch (e) {
        notify.apiError(e);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerTypeId]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Preserve indicators and classificationCriterias from fullData
      const payload = {
        ...fullData,
        ...form,
      };
      await updateCustomerType(payload);
      notify.success(t("message.update.success"));
      navigate(`/design/${businessDomainId}/customer-types/${customerTypeId}`);
    } catch (err) {
      notify.apiError(err);
    }
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>
        {t("customerType.edit.title")}
      </Typography>

      <Box component="form" onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid size={12}>
            <TextField
              fullWidth
              required
              multiline
              label={t("customerType.name")}
              name="customerTypeName"
              value={form.customerTypeName}
              onChange={handleChange}
            />
          </Grid>

          <Grid size={12}>
            <FormControl component="fieldset">
              <RadioGroup
                row
                name="personality"
                value={form.personality}
                onChange={handleChange}
              >
                <FormControlLabel value="Person" control={<Radio />} label={t("customerType.personality.person")} />
                <FormControlLabel value="Company" control={<Radio />} label={t("customerType.personality.company")} />
              </RadioGroup>
            </FormControl>
          </Grid>

          <Grid size={12}>
            <TextField
              fullWidth
              required
              multiline
              rows={3}
              label={t("customerType.values")}
              name="values"
              value={form.values}
              onChange={handleChange}
            />
          </Grid>
        </Grid>

        <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
          <Button variant="contained" type="submit">
            {t("common.save")}
          </Button>
          <Button variant="outlined" onClick={() => navigate(`/design/${businessDomainId}/customer-types/${customerTypeId}`)}>
            {t("common.cancel")}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
